<template>
  <Layout footer>
    <NSpin :show="initLoading" :class="{ 'py-40': initLoading }">
      <div class="app-container" v-if="!initLoading">
        <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
          <span class="mr-1">当前位置：</span>
          <NBreadcrumb>
            <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
            <NBreadcrumbItem>学习中心</NBreadcrumbItem>
            <NBreadcrumbItem>结业证书</NBreadcrumbItem>
          </NBreadcrumb>
        </div>
        <div class="mt-7 p-10 border border-gray-300">
          <div class="flex items-start pb-28 border-b-2 border-dashed border-gray-300">
            <img style="width: 225px" class="flex-shrink-0" :src="imgBaseUrl + userInfo.photo" alt="头像信息" />
            <div class="ml-20">
              <p class="text-xl">{{ userInfo.stuName }}</p>
              <p class="mt-4 text-gray-500 text-base"> 机构：{{ userInfo.tenantName }} </p>
              <p class="mt-2 text-gray-500 text-base">班级：{{ userInfo.className }}</p>
              <p class="mt-2 text-gray-500 text-base">班主任：{{ userInfo.headTeacherName }}</p>
              <p class="mt-4 text-base" style="color: #DF1A23">
                结业时间：{{ userInfo.certificateOfCompletionDate || '-' }}
              </p>
            </div>
            <n-button type="primary" class="ml-auto">
              {{ flag ? '未结业' : '已结业' }}
            </n-button>
          </div>
          <div class="flex items-center mt-4" v-if="conceal">
            <div class="inline-block py-1 text-xl border-b-2 border-dashed border-gray-300">
              结业证书
            </div>
            <n-button type="primary" class="ml-auto">打印</n-button>
            <n-button type="primary" class="ml-4">下载 PDF</n-button>
            <n-button type="primary" class="ml-4" @click="getPdfxai">下载图片</n-button>
          </div>
          <div class="mb-8 mt-10 text-base" id="policy-information"
            style="height: 700px; height: 700px; padding-top: 33px">
            <div v-html="content"></div>
          </div>
        </div>
      </div>
    </NSpin>
  </Layout>
</template>

<script setup>
import html2canvas from 'html2canvas';
import { useRouter } from 'vue-router';
import Layout from '@/components/Layout';
import { reactive, ref } from 'vue';
import {
  getUserInfoApi,
  verifyCertificateOfConformityApi,
  getCertificateOfConformityApi,
} from '@/api';

const router = useRouter();
function gotoHome () {
  router.push('/');
}

const flag = ref(true);
verifyCertificateOfConformityApi().then(res => {
  flag.value = res.data;
});

const conceal = ref(false);

const content = ref(null);
const imgBaseUrl = 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/';
const userInfo = reactive({});
const initLoading = ref(false);
getUserInfoApi()
  .then(res => res.data)
  .then(res => {
    const { photo, stuName, tenantName, className, headTeacherName, certificateOfCompletionDate } =
      res;
    Object.assign(userInfo, {
      photo,
      stuName,
      tenantName,
      className,
      headTeacherName,
      certificateOfCompletionDate,
    });

    // console.log(res);
    getCertificateOfConformityApi({ stuIds: res.id }).then(res => {
      content.value = res.data;
      if (res.data.length === 1) {
        conceal.value = true;
      } else {
        conceal.value = false;
      }
    });
  })
  .finally(() => (initLoading.value = false));

// 下载图片
function getPdfxai () {
  var target = document.getElementById('policy-information'); // policy-information是html的id信息
  // target.style.background = "#FFFFFF";
  html2canvas(target, {
    useCORS: true,

    // dpi: 300,
    // "imageTimeout": 0,
    // 'scale': 2,
  }).then(canvas => {
    var contentWidth = canvas.width;
    var contentHeight = canvas.height;
    // 一页pdf显示html页面生成的canvas高度;
    var pageHeight = (contentWidth / 592.28) * 841.89;
    // 未生成pdf的html页面高度
    var leftHeight = contentHeight;
    // 页面偏移
    var position = 0;
    // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28;
    var imgHeight = (592.28 / contentWidth) * contentHeight;
    var pageData = canvas.toDataURL('image/png', 1.0);
    var url = pageData; // 获取图片地址
    var a = document.createElement('a'); // 创建一个a节点插入的document
    // console.log(a)
    var event = new MouseEvent('click'); // 模拟鼠标click点击事件
    a.download = userInfo.stuName; // 设置a节点的download属性值
    a.href = url; // 将图片的src赋值给a节点的href
    a.dispatchEvent(event);
  });
}
</script>

<style lang="scss" scoped>
//:deep(.n-breadcrumb-item) {
//  font-size: 16px;
//}
</style>
